
import login from './zh-CN-login.json'
import plan from './zh-CN-plan.json'

export default {
  sideBar: {
    dashboard: '仪表盘',
    product: '商品管理',
    user: '用户管理',
    order: '订单管理',
    tag: '标签管理',
    plan: '计划管理',
    store: '店铺管理',
    subsidiary: '子公司管理',
    channel: '渠道管理',
    admin: '账户管理',
    logs: '日志',
    vechainorder: '标签订单'
  },
  headBar: {
    logout: '注销',
    change_pwd: '修改密码',
    lang: 'Language',
    en: 'English',
    cn: '中文'
  },
  product: {
    tt_sku: 'SKU',
    tt_name: '商品名',
    tt_size: '尺寸',
    tt_color: '颜色',
    tt_category: '类别',
    tt_more: '更多',
    list_title: '商品管理',
    form_name: '商品名',
    form_sku: 'SKU',
    form_ean: 'Code EAN',
    form_category: '类别',
    form_color: '颜色',
    form_size: '尺寸',
    form_material: '材质',
    form_dimension: '长x宽x高',
    form_desp: '详细描述',
    msg_up_suces: '上传成功',
    msg_up_failed: '上传失败',
    code_ean: 'EAN码'
  },
  order: {
    list_title: '订单管理',
    tt_id: '订单号',
    tt_sole_count: '售出数量',
    tt_return_count: '退回数量',
    tt_ship_date: '出货日期',
    tt_more: '更多',
    search: 'SKU',
    detail_id: '标签 ID',
    detail_sku: 'SKU',
    detail_num: '序号',
    detail_by: '准备人',
    detail_return_by: '退货检查人',
    detail_comment: '备注',
    list_search: '订单号',
    date_range: '日期范围',
    comment_time: '时间',
    due_date: '到期时间',
    cancel_order: '请确认取消发货!',
    alert: '提示',
    sure: '确定',
    cancel_success: '取消发货成功!',
  },
  
  common: {
    search: '搜索',
    opera_view: '详情',
    opera_edit: '编辑',
    opera_add: '添加',
    opera_save: '保存',
    opera_create: '创建',
    opera_export: '导出',
    opera_confirm: '确定',
    opera_cancel_order: '取消发货',
    opera_download_pictures: "下载图片",
    opera_back: '返回',
    opera_delete: '删除',
    reset_pwd: '重置密码',
    upload: '上传',
    error_required: '必填项!',
    error_positive_num: '数量必须大于0!',
    msg_up_suces: '上传成功',
    msg_up_failed: '上传失败',
    no_data: '无数据',
    select: '请选择',
    selected: '已选择',
    confirm: '确定',
    subsidiary: '子公司',
    channel: '渠道',
    status: '状态',
    batchNumber: '批次号',
    dueTime: '过期时间',
    tagId: '标签ID',
    sku: 'SKU',
    action: '状态',
    comment: '说明',
    time: '记录时间',
    operator: '操作人'
  },
  user: {
    list_title: '用户管理',
    tt_name: '用户名',
    tt_type: '类型',
    tt_location: '位置',
    tt_code: '位置码',
    tt_more: '更多',
    form_name: '用户名',
    form_type: '类型',
    form_location: '位置',
    reset_pwd: '请确定是否重置密码？(如您有任何疑问请联系技术支持团队)',
    delete_user: '请确定是否删除此用户？',
    alert: '提示',
    sure: '确定',
    reset_success: '重置密码成功!',
    delete_success: '删除用户成功!',
    form_identifycode: '位置码',
    add_success: '添加用户成功!',
    list_search: '用户名',
    source: '始发地',
    destination: '目的地',
    special_user: '特殊',
    edit_pictures: '编辑图片'
  },
  changePwd: {
    title: '修改密码',
    old_pass: '旧密码',
    new_pass: '新密码',
    check_pass: '确认密码',
    change: '确认',
    new_pass_error: '两次密码不同',
    requirement:'密码不符合要求',
    success: '修改密码成功!',
    verify_code: '验证码',
    send_sms: '验证码已发送至你的手机',
    get_code: '获取验证码',
    countdown: '{auth_time}秒之后重新发送验证码'
  },
  store: {
    list_title: '店铺管理',
    list_id: '店铺 ID',
    list_type: '类型',
    list_location: '位置',
    list_location_code: '位置码',
    list_channel_code: '渠道码',
    list_subsidiary_code: '子公司码',
    list_subsidiary: '子公司名',
    list_channel: '渠道名',
    prefix: '前缀'

  },
  subsidiary: {
    subsidiary_title: '子公司管理',
    subsidiary_name: '子公司名称',
    subsidiary_code: '子公司Code',
    vechain_url: '芯片链接',
    description: '描述',
    add_success: '成功添加子公司!'
  },
  channel: {
    channel_title: '渠道管理',
    channel_name: '渠道名称',
    channel_code: '渠道码',
    description: '描述',
    add_success: '成功添加渠道!'

  },
  error: {
    error1001: '对不起，请登录',
    error1002: '无效的登录，请尝试再次登录',
    error1003: '无效的登录，请尝试再次登录',
    error1004: '对不起，密码错误，请再试一次',
    error1005: '无效的Code_EAN, 请再试一次',
    error1006: '无效的标签, 请联系技术支持',
    error1007: '无效的SKU, 请联系技术支持',
    error1009: '导入失败, 请检查excel文件的格式',
    error1010: '订单不存在',
    error1011: '此用户名已存在',
    error1012: '无效的用户名',
    error1018: '无效的店铺ID',
    error9000: '对不起，用户名或密码有误, 请再试一次',
    error9001: "您的登陆方式错误，请切换域登陆或用户名密码方式",
    error_default: '未知错误，请联系技术支持'
  },
  dashboard: {
    title: '仪表盘',
    today: '今日',
    history: '历史',
    orders_chart_title: '订单',
    products_chart_title: '商品比例',
    category_chart_title: '类别比例',
    return_table_title: '退货详情',
    days_7: '7 天',
    days_14: '14 天',
    days_30: '30 天',
    today_orders: '订单',
    today_return: '退货',
    today_products: '商品',
    today_category: '类别',
    table_location_code: '门店Code',
    table_count: '退货数量',
    table_create_time: '最新退货时间'
  },
  logs:{
    action:'操作',
    date:'日期',
    title:'日志',
    ip_address:'IP地址',
    type:'类型',
    detail:'详情'
  },
  admin: {
    title: '账户管理',
    account: '账户',
    realname: '名字',
    type: '类型',
    adminlevel: '类型',
    mobile: '手机',
    Managed: '权限',
    disabled: '禁用',
    description: '描述',
    enable_cancel: '取消发货',
    enable_order: '创建标签订单',
    email: '邮箱',
    add_success: '添加管理员成功!',
    update_success: '更新管理员成功!',
  },
  vechainorder: {
    title: '标签订单',
    opera_order: '下单',
    request_num: '请求单号',
    order_num: '订单号',
    product_id: '产品ID',
    product_name: '产品名称',
    quantity: '数量',
    package_count: '包裹数量',
    operator_name: '下单用户',
    receiver: '收货人',
    order_time: '下单时间',
    status: '状态',
    more: '更多',
    detail: '详情',
    confirm: '确认收货',
    import: '导入标签',
    confirm_request: '您要确认收货吗?',
    alert: '提示',
    sure: '确认',
    confirm_success: '确认收货成功！请稍后刷新页面查看导入标签结果！',
    import_request: '您要导入标签吗?',
    import_success: '请稍后刷新页面查看导入标签结果！',
    order_success: '下单成功！',
    subsidiary: '子公司',
    channel: '渠道',
    vechain_url: '芯片链接'
  },
  vechainorder_detail: {
    tag_info: '产品信息',
    product_id: '产品ID',
    product_name: '产品名称',
    quantity: '数量',
    total_price: '总价格',
    receiver_info: '收货信息',
    receiver: '收货人',
    address: '收货地址',
    email: '邮件地址',
    telephone: '电话',
    logistic_info: '物流信息',
    logistic_number: '物流号',
    logistic_time: '发货时间',
    logistic_comment: '备注',
    chipUrl: '芯片链接'
  },
  plan,
  login
}



// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js